import { IInputOptions, IRichText } from '@modeso/types__aumico-lib-notes-be';
import { IComponentOptionsProperties } from '../interfaces/IComponentOptionsProperties.interface';

export type DialogTypes = IComponentOptionsProperties | IRichText[] | IInputOptions;
